import { styled } from '@mui/material';
import React, { useState } from 'react';
const FileUploadBox = () => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleDrop = (e) => {
        e.preventDefault();
        setSelectedFile(e.dataTransfer.files[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const closeSelectFile = () => {
        setSelectedFile('');
    }

    return (
        <div className="mb-4">
            <label className="form-label fw-medium text-dark mb-2 fw-semibold" style={{ fontFamily: 'Manrope' }}>File</label>

            <div onDrop={handleDrop} onDragOver={handleDragOver}
                className="border-2 border-dashed rounded-md p-4 px-20 text-center d-flex flex-column align-items-center justify-content-center gap-2 tailwind-shadow-sm transition hover:bg-blue-50"
                style={{ minHeight: '220px', cursor: 'pointer', borderColor: '#0076FE', borderRadius: '10px' }}>
                <div className="text-primary mb-0 mt-28">
                    <img src="./assets/images/insights/file/file-upload.svg" alt='file upload' className="img-fluid" />
                </div>
                <p className="mb-0 text-secondary" style={{ fontSize: '14px', fontFamily: 'Manrope' }}>Drag and drop your file here or browse to upload.</p>
                <div className="d-flex align-items-center w-100 gap-2 text-muted">
                    <hr className="flex-grow-1" />
                    <span className="small" style={{ fontFamily: 'Manrope' }}>OR</span>
                    <hr className="flex-grow-1" />
                </div>

                <label className="btn btn-outline-primary px-16 py-8" style={{ fontFamily: 'Manrope' }}>
                    Browse files
                    <input
                        type="file"
                        accept=".csv, .xls, .xlsx"
                        className="d-none"
                        onChange={handleFileChange}
                    />
                </label>

                <div className="text-muted small pt-8 pb-28" style={{ fontSize: '12px', fontFamily: 'Manrope' }}>
                    Accepted file formats: .CSV, .XLS, .XLSX
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'  }}>
                    <div>
                        {selectedFile && (
                            <div className="mt-2 text-success small" style={{ fontFamily: 'Manrope' }}>
                                Selected file: <strong>{selectedFile.name}</strong>
                            </div>
                        )}
                    </div>
                    {
                        selectedFile ? (<div onClick={closeSelectFile}>
                            <div id='closeimgtag'>
                                <img style={{ height: '20px' , marginBottom: '2px' }} src='https://cdn-icons-png.flaticon.com/128/14035/14035689.png'></img>
                            </div>
                        </div>) :
                            false
                    }


                </div>
            </div>

            <div className="mt-3">
                <a href="" className="text-primary text-decoration-none fw-semibold" style={{ fontSize: '14px', fontFamily: 'Manrope' }} download>
                    Download the template here
                </a>
            </div>
        </div>
    );
};

export default FileUploadBox;
